import React, { Component } from 'react'

export class Timelimit extends Component {
    render() {
        return (
                <div className="box">
                <div className="box-body">
                    <div className="box-header">
                        <h3 className="box-title">Time Limit</h3>
                    </div>
                    <form action="partworksdetails/savetimelimit">
                        <div className="col-md-12" >
                            <div className="col-md-4" >
                            <div className="form-group">
                                <label>By</label>
                                <select name="status" className="form-control">
                                    <option value="">Select By</option>
                                    <option value="1">Forwarded</option>
                                    <option value="2">Approved</option>
                                </select>
                            </div>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="col-md-6" >
                            <div className="form-group">
                                <label>Forwarded to</label>
                                <select name="timeforwarded" className="form-control">
                                    <option value="">Select Forwarded to</option>
                                </select>
                            </div>
                            </div>
                            <div className="col-md-6" >
                            <div className="form-group">
                                <label>Forwarding No.</label>
                                <input type="text" name="forwardingno" className="form-control" />
                            </div>
                            </div>
                            <div className="col-md-6" >
                            <div className="form-group">
                                <label>Date of Forwarding</label>
                                <input type="text" placeholder="DD-MM-YYYY" name="forwardeddate" className="form-control" />
                            </div>
                            </div>
                            <div className="col-md-6" >
                            <div className="form-group">
                                <label>Proposed Stipulated Date of Completion</label>
                                <input type="text" placeholder="DD-MM-YYYY" name="proposedstipdate" className="form-control" />
                            </div>
                            </div>
                        </div>
                        <div className="col-md-12" id="getdetailsafterapproved" >
                            <div className="col-md-6" >
                            <div className="form-group">
                                <label>Approved By</label>
                                <select name="timeapproval" className="form-control" >
                                    <option value="">Select Approved By</option>
                                </select>
                            </div>
                            </div>
                            <div className="col-md-6" >
                            <div className="form-group required">
                                <label className="control-label">Approval No.</label>
                                <input type="text" name="approvalno" className="form-control" />
                            </div>
                            </div>
                            <div className="col-md-6" >
                            <div className="form-group">
                                <label>Approval Date</label>
                                <input type="text" placeholder="DD-MM-YYYY" name="approvaldate" className="form-control" />
                            </div>
                            </div>
                            <div className="col-md-6" >
                            <div className="form-group">
                                <label>New Stipulated Date of Completion</label>
                                <input type="text" placeholder="DD-MM-YYYY" name="newstipdate" className="form-control" />
                            </div>
                            </div>
                        </div>
                        <div className="col-md-12" >
                            <div className="col-md-6" >
                            <input type="submit" className="btn btn-primary" value="Save" />
                            </div>
                        </div>
                    </form>
                    <h5 className="text-center">List Of Forwarding</h5>
                    <div className="col-md-12 table-responsive" >
                        <table className="table table-bordered">
                            <thead>
                            <tr className="bg-gray">
                            <th className="text-center">Forwarded To.</th>
                            <th className="text-center">Forwarding No.</th>
                            <th className="text-center">Forwarded Date</th>
                            <th className="text-center">Proposed Stipulated Date of Completion</th>
                            <th className="text-center">Edit</th>
                            <th className="text-center">Delete</th>
                            </tr>
                            </thead>
                        </table>
                    </div>
                    <h5 className="text-center">List Of Approval</h5>
                    <div className="col-md-12 table-responsive" >
                        <table className="table table-bordered">
                        <thead>
                            <tr className="bg-gray">
                            <th className="text-center">Approval Authority</th>
                            <th className="text-center">Approval No.</th>
                            <th className="text-center">Approval Date</th>
                            <th className="text-center">New Stipulated Date of Completion</th>
                            <th className="text-center">Edit</th>
                            <th className="text-center">Delete</th>
                            </tr>
                            </thead>
                        </table>
                    </div>
                </div>
                </div>
        )
    }
}

export default Timelimit
